"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS = {
    open: "Open",
    overdue: "Overdue",
    completed: "Completed",
    rejected: "Rejected",
    submitted: "Awaiting Approval"
};
exports.TASK_TYPE = {
    dd: "Digital Document",
    form: "Form",
    scan: "Scan"
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFzay5jb25zdGFudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbnN0YW50L3Rhc2suY29uc3RhbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLE1BQU0sR0FBRztJQUNsQixJQUFJLEVBQUUsTUFBTTtJQUNaLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFNBQVMsRUFBRSxtQkFBbUI7Q0FDakMsQ0FBQTtBQUVZLFFBQUEsU0FBUyxHQUFHO0lBQ3JCLEVBQUUsRUFBRSxrQkFBa0I7SUFDdEIsSUFBSSxFQUFFLE1BQU07SUFDWixJQUFJLEVBQUUsTUFBTTtDQUNmLENBQUEifQ==